import styled from 'styled-components'
import theme from '../../themes/light'

export default styled.div`
  border-top: 1px solid ${theme.menuDivider};
  margin: .5rem 7px;
`
